<template>
  <v-app>
    <v-container
      fluid
      tag="section"
      class="pt-0"
    >
      <v-row justify="center">
        <v-col
          cols="12 px-6"
        >
          <v-row>
            <v-col class="py-0">
              <v-img
                contain
                src="logo.png"
                height="4rem"
                width="8rem"
              />
            </v-col>
          </v-row>
          <v-card
            flat
            height="12rem"
            class="d-flex align-center justify-center"
          >
            <v-icon
              size="8rem"
              color="green"
            >
              mdi-check-circle-outline
            </v-icon>
          </v-card>
          <v-row>
            <v-col
              cols="12"
              class="text-center payment-message pa-1"
            >
              Оплата успешна
            </v-col>
            <v-col class="text-center payment-message2 pa-1">
              {{ Number(this.order.sumFull).money() }}
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <v-text-field
                v-model="email"
                dense
                hide-details
                outlined
                label="Введите свой e-mail"
              />
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12">
              <v-btn
                width="100%"
                depressed
                @click="onSendCheque"
              >
                Отправить чек
              </v-btn>
            </v-col>
          </v-row>
          <v-row>
            <v-col
              v-if="showMessage"
              cols="12"
              class="text-center py-1"
            >
              {{ this.message }}
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-container>
  </v-app>
</template>

<style scoped>
.payment-message {
  font-size: 1.5rem;
  font-weight: 400;
}
.payment-message2 {
  font-size: 2rem;
  font-weight: 700;
}
</style>
<script>
import { JustpayQrPaymentService } from "@/views/loyalty/shared/services/justpay-qrpayment-service"
import { JustpayOrderModel } from "@/views/loyalty/models/justpay-order.model"

export default {
  data: () => ({
    email: null,
    message: '',
    order: new JustpayOrderModel(),
    showMessage: false
  }),
  async beforeMount () {
    const orderNumber = this.$route.query.reference
    this.justpayQrPaymentService = new JustpayQrPaymentService()
    const order = await this.justpayQrPaymentService.getOrderByNumber(orderNumber)
    this.order = new JustpayOrderModel(order)
  },
  methods: {
    async onSendCheque () {
      if (this.email) {
        this.message = await this.justpayQrPaymentService.sendCheque(this.order.orderId, this.email)
        this.showMessage = true
        setTimeout(() => { this.showMessage = false }, 5000)
      }
    }
  }
}
</script>
